import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7088f309"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "memberinfo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 textcenter" }, "Medlemsinfo", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "row justify--center mt-4" }
const _hoisted_5 = { class: "flex md12 center size" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ups der var et eller andet der gik galt", -1))
const _hoisted_7 = { class: "flex md6 center size mt-2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Tilbage til forsiden")
const _hoisted_9 = { class: "flex md6 center size mt-2" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Til licensoversigt")
const _hoisted_11 = {
  key: 1,
  class: "memberarea layout gutter--lg mt-4"
}
const _hoisted_12 = { class: "row justify--space-between" }
const _hoisted_13 = { class: "flex md5 xs12" }
const _hoisted_14 = { class: "box" }
const _hoisted_15 = { class: "display-3" }
const _hoisted_16 = { class: "size" }
const _hoisted_17 = { class: "size" }
const _hoisted_18 = { class: "size" }
const _hoisted_19 = {
  key: 0,
  class: "size"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Klub: ")
const _hoisted_21 = { class: "flex md7 xs12" }
const _hoisted_22 = {
  key: 0,
  class: "box mb-2"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "textcenter display-5 mb-2" }, "Seneste kamp", -1))
const _hoisted_24 = { class: "center size" }
const _hoisted_25 = { class: "center size" }
const _hoisted_26 = {
  key: 1,
  class: "box mb-2"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "textcenter display-5" }, "Seneste stævner", -1))
const _hoisted_28 = {
  key: 0,
  class: "va-table-responsive row"
}
const _hoisted_29 = { class: "flex md12 va-table va-table--clickable va-table--hoverable" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "textcenter" }, "Dato"),
    /*#__PURE__*/_createElementVNode("th", null, "Stævne"),
    /*#__PURE__*/_createElementVNode("th", null, "Række"),
    /*#__PURE__*/_createElementVNode("th", { class: "textcenter" }, "Placering"),
    /*#__PURE__*/_createElementVNode("th", { class: "textcenter" }, "Ranglistepoint")
  ])
], -1))
const _hoisted_31 = { class: "textcenter" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "textcenter" }
const _hoisted_35 = { class: "textcenter" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, [
  /*#__PURE__*/_createElementVNode("i", null, "Ranglistepoints lige nu:")
], -1))
const _hoisted_39 = { class: "textcenter" }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "size textcenter mt-2" }, [
  /*#__PURE__*/_createElementVNode("i", null, "Ingen resultater indenfor det sidste år")
], -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "row justify--center mt-2" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Se alle resultater")
const _hoisted_45 = {
  key: 2,
  class: "memberarea layout gutter--lg mt-4"
}
const _hoisted_46 = { class: "va-table-responsive" }
const _hoisted_47 = { class: "va-table--striped statistics va-table" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Sæson"),
    /*#__PURE__*/_createElementVNode("th", null, "Klub"),
    /*#__PURE__*/_createElementVNode("th", null, "Hold"),
    /*#__PURE__*/_createElementVNode("th", null, "Turnering"),
    /*#__PURE__*/_createElementVNode("th", null, "Kampe"),
    /*#__PURE__*/_createElementVNode("th", null, "Vundne"),
    /*#__PURE__*/_createElementVNode("th", null, "Vundne %"),
    /*#__PURE__*/_createElementVNode("th", null, "Dart for vundne sæt"),
    /*#__PURE__*/_createElementVNode("th", null, "Snit"),
    /*#__PURE__*/_createElementVNode("th", null, "180"),
    /*#__PURE__*/_createElementVNode("th", null, "Højeste lukker"),
    /*#__PURE__*/_createElementVNode("th", null, "Hurtigste sæt")
  ])
], -1))
const _hoisted_49 = { class: "center" }
const _hoisted_50 = { class: "center" }
const _hoisted_51 = { class: "center" }
const _hoisted_52 = { class: "center" }
const _hoisted_53 = { class: "center" }
const _hoisted_54 = { class: "center" }
const _hoisted_55 = { class: "center" }
const _hoisted_56 = { class: "center" }
const _hoisted_57 = { class: "display-6 textcenter mb-2" }
const _hoisted_58 = { class: "row justify--center" }
const _hoisted_59 = { class: "flex" }
const _hoisted_60 = { class: "va-table-responsive row" }
const _hoisted_61 = { class: "flex md12 va-table va-table--clickable va-table--hoverable" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "textcenter" }, "Dato"),
    /*#__PURE__*/_createElementVNode("th", null, "Stævne"),
    /*#__PURE__*/_createElementVNode("th", null, "Række"),
    /*#__PURE__*/_createElementVNode("th", { class: "textcenter" }, "Placering"),
    /*#__PURE__*/_createElementVNode("th", { class: "textcenter" }, "Ranglistepoint")
  ])
], -1))
const _hoisted_63 = { class: "textcenter" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { class: "textcenter" }
const _hoisted_67 = { class: "textcenter" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode("Luk")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("p", null, _toDisplayString('Fejl: ' + _ctx.error), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_router_link, { to: "/medlemmer" }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.medlemData.brugerFornavn + ' ' + _ctx.medlemData.brugerEfternavn), 1),
                _createVNode(_component_va_chip, {
                  class: "mb-2",
                  square: "",
                  color: _ctx.havePlayerLicense(_ctx.medlemData.medlemStatus, _ctx.medlemData.medlemLicensSlut) ? 'success': 'danger'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString((_ctx.havePlayerLicense(_ctx.medlemData.medlemStatus, _ctx.medlemData.medlemLicensSlut) ? 'Har aktiv licens': 'Har ingen licens')), 1)
                  ]),
                  _: 1
                }, 8, ["color"]),
                _createElementVNode("p", _hoisted_16, "Licens: " + _toDisplayString(_ctx.medlemData.medlemLicens), 1),
                _createElementVNode("p", _hoisted_17, "Alder: " + _toDisplayString(_ctx.calcAge(_ctx.medlemData.medlemFoedselsdag)) + " år", 1),
                _createElementVNode("p", _hoisted_18, "Køn: " + _toDisplayString(_ctx.medlemData.medlemKoen), 1),
                (_ctx.medlemData.klubNavn !== '')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                      _hoisted_20,
                      _createVNode(_component_router_link, {
                        to: { name: 'theClub', params: { slug: _ctx.medlemData.klubSlug },}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.medlemData.klubNavn), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              (_ctx.tournamentHistory.length > 0 && _ctx.lastMatchData.homeTeamId !== null && _ctx.lastMatchData.guestTeamId !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("p", _hoisted_24, [
                      _createElementVNode("i", null, _toDisplayString(_ctx.toDanishDateString(_ctx.lastMatchData.datePlayed)), 1)
                    ]),
                    _createElementVNode("p", {
                      class: "center sorting size",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toMatchSchedule()))
                    }, _toDisplayString(_ctx.lastMatchData.seriesName), 1),
                    _createElementVNode("p", _hoisted_25, [
                      _createTextVNode(_toDisplayString(_ctx.lastMatchData.homeTeamName) + " ", 1),
                      _createElementVNode("span", {
                        class: "results sorting",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toMatchResults()))
                      }, _toDisplayString(_ctx.lastMatchData.homeScore + '-' + _ctx.lastMatchData.guestScore), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.lastMatchData.guestTeamName), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.currentResults.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _hoisted_27,
                    (_ctx.currentResults.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("table", _hoisted_29, [
                            _hoisted_30,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentResults, (result, index) => {
                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                  _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.toDanishDateString(result.date)), 1),
                                  (result.foreign)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_32, _toDisplayString(result.competitionName), 1))
                                    : (_openBlock(), _createElementBlock("td", _hoisted_33, [
                                        _createVNode(_component_router_link, {
                                          to: {name: 'Competition', params: { slug: _ctx.generateSlug(result.competitionId, result.competitionName, result.competitionStart) }, }
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(result.competitionName), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ])),
                                  _createElementVNode("td", null, _toDisplayString(result.series), 1),
                                  _createElementVNode("td", _hoisted_34, _toDisplayString(result.placement), 1),
                                  _createElementVNode("td", _hoisted_35, _toDisplayString(result.points), 1)
                                ]))
                              }), 128)),
                              _createElementVNode("tr", null, [
                                _hoisted_36,
                                _hoisted_37,
                                _hoisted_38,
                                _createElementVNode("td", _hoisted_39, [
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.calcHighestTotal(_ctx.currentResults)), 1)
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42)),
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_component_va_button, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayHistoricalResults()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_44
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.error && _ctx.statisticsData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("table", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statisticsData, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: "statisticsRow"
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.seasonName), 1),
                    _createElementVNode("td", null, _toDisplayString(item.clubName), 1),
                    _createElementVNode("td", null, _toDisplayString(item.teamName), 1),
                    _createElementVNode("td", null, _toDisplayString(item.seriesName), 1),
                    _createElementVNode("td", _hoisted_49, _toDisplayString(item.noMatches), 1),
                    _createElementVNode("td", _hoisted_50, _toDisplayString(item.wonMatches), 1),
                    _createElementVNode("td", _hoisted_51, _toDisplayString(item.winRatio), 1),
                    _createElementVNode("td", _hoisted_52, _toDisplayString(item.dartingForWonSet), 1),
                    _createElementVNode("td", _hoisted_53, _toDisplayString(item.setAverage), 1),
                    _createElementVNode("td", _hoisted_54, _toDisplayString(item.oneEighty), 1),
                    _createElementVNode("td", _hoisted_55, _toDisplayString(item.highestClose), 1),
                    _createElementVNode("td", _hoisted_56, _toDisplayString(item.fastestDarting), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.memberResultsModal,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.memberResultsModal) = $event)),
      size: "large",
      "overlay-opacity": "0.5",
      "hide-default-actions": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_va_button, {
          class: "btn",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.memberResultsModal = false))
        }, {
          default: _withCtx(() => [
            _hoisted_68
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("h6", _hoisted_57, "Alle resultater for " + _toDisplayString(_ctx.medlemData.brugerFornavn + ' ' + _ctx.medlemData.brugerEfternavn), 1),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.historicalResultsValue,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.historicalResultsValue) = $event)),
              options: _ctx.historicalResultsOptions,
              bordered: "",
              label: "Resultater fra"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("table", _hoisted_61, [
            _hoisted_62,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.historicalResults, (result, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.toDanishDateString(result.date)), 1),
                  (result.foreign)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_64, _toDisplayString(result.competitionName), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_65, [
                        _createVNode(_component_router_link, {
                          to: {name: 'Competition', params: { slug: _ctx.generateSlug(result.competitionId, result.competitionName, result.competitionStart) }, }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(result.competitionName), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])),
                  _createElementVNode("td", null, _toDisplayString(result.series), 1),
                  _createElementVNode("td", _hoisted_66, _toDisplayString(result.placement), 1),
                  _createElementVNode("td", _hoisted_67, _toDisplayString(result.points), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}